import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=e5a5e63a&"
import script from "./page2.vue?vue&type=script&lang=js&"
export * from "./page2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports